import Button from 'atoms/button';
import { ESTABLISHMENT_CLICKOUT_SECTIONS } from 'templates/establishment/constants';
import { partnerInterface } from 'constants/interfaces';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from 'atoms/tooltip';


export default function GridMatchingRow({ className, country, handleOnClick, partner, rating, t }) {
  const { cancellationPolicy, id, instantlyBooking, priceTotal } = partner;
  const hasFreeCancellation = cancellationPolicy && '100' in cancellationPolicy;
  const hasCancellation = cancellationPolicy && !(Object.keys(cancellationPolicy).length === 0);
  const showComments = partner.comments > 0;
  const PARTNERS_WITH_MULTI_LOGO = { 12: ["de", "fr"] };
  const imageContainerClassName = Object.keys(PARTNERS_WITH_MULTI_LOGO).includes(String(id))
  && PARTNERS_WITH_MULTI_LOGO[id].includes(country)
    ? `logo-container_${id}_${country}`
    : `logo-container_${id}`;

  const extras = () => (
    <div>
      { hasCancellation
        && (
          <Tooltip
            baseClassName="grid-matching-row__logo__extras__tooltip__cancellation"
            position="bottom"
            title={ hasFreeCancellation ? cancellationPolicy['100'] === 0
              ? t("Holiday rental with free cancellation until the day of your arrival.")
              : t("Holiday rental with free cancellation up to {cancellationPolicyDays} days before your arrival.", { cancellationPolicyDays: cancellationPolicy['100'] })
              : Object.values(cancellationPolicy)[0] === 0
                ? t("This holiday rental is partially refundable up to the check-in date.")
                : t("This holiday rental is partially refundable up to {cancellationPolicyDays} days before the check-in date.", { cancellationPolicyDays: Object.values(cancellationPolicy)[0] }) }
            tooltipX={ 65 }
            tooltipY={ 100 }
          >
            <span className={ `hundredicons-cancellation minified ${hasFreeCancellation ? 'full' : 'partial'}` } />
          </Tooltip>
        )
      }
      { instantlyBooking
        && (
          <Tooltip
            baseClassName="grid-matching-row__logo__extras__tooltip__instant-book"
            position="bottom"
            title={ t("With instant book you can book without waiting for host approval") }
            tooltipX={ 65 }
            tooltipY={ 100 }
          >
            <span className="hundredicons-instantbook" />
          </Tooltip>
        )
      }
    </div>
  );


  return (
    <div className={ `grid-matching-row ${className}` }>
      <span className={ `grid-matching-row__logo ${!showComments ? '-no-comments' : ''}` }>
        <div className={ `grid-matching-row__logo__image-container ${imageContainerClassName}` } onClick={ handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_LOGO) }>
          <img
            alt={ `partner-${id}-logo` }
            className="grid-matching-row__logo__image-container__image"
            src="/img/partner-logos/sprite-logos.png"
          />
        </div>
        { instantlyBooking || hasCancellation
          ? (
            <div className="grid-matching-row__logo__extras" onClick={ handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_EXTRAS) }>
              { extras() }
            </div>
          ) : null
        }
        { showComments
          ? (
            <div className="grid-matching-row__logo__comments" onClick={ handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_COMMENTS) }>
              { `${partner.comments} ${partner.comments > 1 ? t('comments') : t('comment')}` }
            </div>
          ) : null
        }
      </span>
      <span className={ `grid-matching-row__rating ${rating ? "" : "-no-pointer"}` } onClick={ rating ? handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_RATING) : null }>
        { rating || '-' }
      </span>
      <span className={ `grid-matching-row__comments ${showComments ? "" : "-no-pointer"}` } onClick={ showComments ? handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_COMMENTS) : null }>
        { showComments ? partner.comments : '-' }
      </span>
      <span className={ `grid-matching-row__price ${priceTotal ? "" : "-no-pointer"}` } onClick={ priceTotal ? handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_PRICE) : null }>
        { priceTotal ? t('£{price}', { price: priceTotal }) : '-' }
      </span>
      <span className={ `grid-matching-row__extras ${instantlyBooking || hasCancellation ? "" : "-no-pointer"}` } onClick={ instantlyBooking || hasCancellation ? handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_EXTRAS) : null }>
        { extras() }
        { !instantlyBooking && !hasCancellation && '-' }
      </span>
      <span className="grid-matching-row__cta">
        <Button
          className="grid-matching-row__cta__button -filled"
          handleOnClick={ handleOnClick.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING_GRID_CTA) }
        >
          <p className="grid-matching-row__cta__button__desktop">
            { priceTotal ? t('View offer') : t('Check') }
          </p>
          <p className="grid-matching-row__cta__button__mobile">
            { priceTotal ? t('£{price}', { price: priceTotal }) : t('Check')}
          </p>
        </Button>
      </span>
    </div>
  );
}

GridMatchingRow.defaultProps = {
  className: '',
  country: '',
  rating: null,
};

GridMatchingRow.propTypes = {
  className: PropTypes.string,
  country: PropTypes.string,
  handleOnClick: PropTypes.func.isRequired,
  partner: partnerInterface.isRequired,
  rating: PropTypes.number,
  t: PropTypes.func.isRequired,
};
